/* FÉNIX 2.1 — Product S04 interaction guard */
(function(){
  'use strict';

  function oneClickSummary(target){
    return target && target.closest ? target.closest('details.nmps__oneclick > summary') : null;
  }

  function sync(details){
    if(!details) return;
    var summary=details.querySelector(':scope > summary');
    if(summary) summary.setAttribute('aria-expanded',details.open ? 'true' : 'false');
  }

  function toggle(details){
    if(!details) return;
    details.open=!details.open;
    sync(details);
  }

  document.addEventListener('click',function(event){
    var summary=oneClickSummary(event.target);
    if(!summary) return;
    var details=summary.parentElement;
    if(!details || !details.classList.contains('nmps__oneclick')) return;

    /* Own the activation explicitly so legacy theme listeners cannot cancel it. */
    event.preventDefault();
    toggle(details);
  },true);

  function initialize(){
    document.querySelectorAll('details.nmps__oneclick').forEach(function(details){
      sync(details);
      details.addEventListener('toggle',function(){ sync(details); });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initialize,{once:true});
  }else{
    initialize();
  }
})();
